<wilson-qualification-v2-select
  [hideLabel]="true"
  [ngModel]="selected$ | async"
  (ngModelChange)="saveSelected($event)"
></wilson-qualification-v2-select>
